import type { EntryPointReferenceSubject } from '@atlassian/jira-entry-point/src/controllers/utils/use-entry-point-load-manager/index.tsx';
import type { IdeaViewBentoSidebarEntryPoint } from '@atlassian/jira-polaris-component-idea-view-bento-sidebar/entrypoint.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createActionsHook, createHook } from '@atlassian/react-sweet-state';

type State = {
	entryPointReferenceSubject: EntryPointReferenceSubject<
		typeof IdeaViewBentoSidebarEntryPoint
	> | null;
	openedOnce: boolean;
};

const initialState: State = {
	entryPointReferenceSubject: null,
	openedOnce: false,
};

const actions = {
	setEntryPointReferenceSubject:
		(
			entryPointReferenceSubject: EntryPointReferenceSubject<
				typeof IdeaViewBentoSidebarEntryPoint
			> | null,
			openedOnce?: boolean,
		) =>
		({ setState, getState }: { setState: (state: State) => void; getState: () => State }): void => {
			if (openedOnce !== undefined) {
				setState({ entryPointReferenceSubject, openedOnce });
				return;
			}
			setState({ ...getState(), entryPointReferenceSubject });
		},
};

const Store = createStore<State, typeof actions>({
	initialState,
	actions,
	name: 'IssueViewJPDIdeasSelectedIdeaStore',
});

export const useActiveEntryPointSubject = createHook(Store, {
	selector: (state) => state.entryPointReferenceSubject,
});

export const useActiveEntryPointSubjectActions = createActionsHook(Store);

export const useOpenedOnce = createHook(Store, {
	selector: (state) => state.openedOnce,
});
